import React, { Component } from 'react';
import { Context } from 'context';

import WindowOptions from 'editor/workspace/window/titlebar/WindowOptions';
import Star from "components/star/Star";

import styles from 'editor/workspace/window/titlebar/titleBar.module.scss';
import ReportMap from "editor/workspace/window/titlebar/ReportMap";

class TitleBar extends Component {
    static contextType = Context;

    handle = React.createRef();

    componentDidMount() {
        this.handle.current.addEventListener("mousedown", e => {
            //close map if middle mouse clicked
            if (e.button === 1) {
                this.context.closeWindow(this.props.id)
            }
        });
    }

    render() {
        const axis = this.props.uploaded.dataAxis;

        const min = axis.min !== null ? axis.min : "none";
        const max = axis.max !== null ? axis.max : "none";

        const minLimit = axis.minLimit !== null ? axis.minLimit : "none";
        const maxLimit = axis.maxLimit !== null ? axis.maxLimit : "none";

        return (
            <div ref={this.handle} className={`${styles.titleBar} ${this.props.focused ? `${styles.focused} highlightTertiary bgTertiary` : "highlightSecondary"} handle `} data-hint={this.context.text.hints.titleBar}>
                <div>
                    {this.props.axisEditingAxisName ?
                        <img src={require(`images/icons/back${this.context.lightTheme ? "-light" : "-dark" }.svg`)} alt="Back" className={styles.backArrow} onClick={this.props.deactivateAxisEditing} />
                    :
                        <Star favourited={this.props.map.favourited} onClick={this.props.toggleMapFavourited} modified={this.props.map.swModified} />
                    }
                    <p className={styles.title} title={this.props.axisEditingAxisName ? `Axis: ${this.props.uploaded.dataAxis.name}` : `${this.props.map.description}: ${this.props.map.nameDescription}`}>
                        {this.props.axisEditingAxisName ? `Axis: ${this.props.uploaded.dataAxis.name}` : this.props.map.nameDescription}
                    </p>
                    <div className={styles.info}>
                        <p data-hint={this.context.text.hints.units}><span>Units:</span> {axis.units}</p>
                        <p data-hint={this.context.text.hints.minMax} title={`Recommended Min: ${min},\nPhysical Min: ${minLimit}`}><span>Min:</span> {min}</p>
                        <p data-hint={this.context.text.hints.minMax} title={`Recommended Max: ${max},\nPhysical Max: ${maxLimit}`}><span>Max:</span> {max}</p>
                    </div>
                </div>
                <div className={styles.more}>
                    {!this.props.axisEditingAxisName ?
                        <WindowOptions
                            valueType={this.props.valueType}
                            diffType={this.props.diffType}
                            viewMode={this.props.viewMode}
                            updateWindow={this.props.updateWindow}
                            table={this.props.table}
                        />
                    : null}

                    <span className={`highlightPrimary ${styles.separator}`}/>
                    <button
                        className="highlightSecondary"
                        onClick={this.props.updateHexToFrom}
                        data-hint={this.context.text.hints.showInHexViewer}
                        onMouseDown={event => event.stopPropagation()}
                        title={"Focus map in Hexviewer"}
                    >
                        <img src={require(`images/icons/crosshair${this.context.lightTheme ? "-light" : "-dark" }.svg`)} alt="Show In Hexviewer"/>
                    </button>
                    <span className={`highlightPrimary ${styles.separator}`}/>
                    <button
                        className="highlightSecondary"
                        onClick={this.props.undo}
                        data-hint={this.context.text.hints.undo}
                        onMouseDown={event => event.stopPropagation()}
                        title={"Undo"}
                    >
                        <img src={require(`images/icons/undo${this.context.lightTheme ? "-light" : "-dark" }.svg`)} alt="Undo"/>
                    </button>
                    <button
                        className="highlightSecondary"
                        onMouseDown={event => event.stopPropagation()}
                        onClick={this.props.revertChanges}
                        data-hint={this.context.text.hints.reset}
                        title={"Reset changes"}
                    >
                        <img src={require(`images/icons/revert${this.context.lightTheme ? "-light" : "-dark" }.svg`)} alt="Reset"/>
                    </button>
                    <span className={`highlightPrimary ${styles.separator}`}/>
                    <ReportMap id={this.props.id}/>
                    <span className={`highlightPrimary ${styles.separator}`}/>
                    <div className={styles.close} onClick={this.props.close.bind(this, this.props.id)}>
                        <img src={require(`images/icons/cross${this.context.lightTheme ? "-light" : "-dark" }.svg`)} alt="Close"  />
                    </div>
                </div>
            </div>
        )
    }
}

export default TitleBar;
